import { TheAddress } from 'ts-back-end/dist/ts-back-end/src/common/types/the-address.dto'
import { CreatePatientDto, UpdatePatientDto, } from 'ts-back-end/src/business/patient/dto/patient.dto'
import { OutputPayer as PayerDto } from 'ts-back-end/src/business/payer/dto/payer.dto'
import type { BillingEraPaymentSummary } from 'ts-back-end/src/business/billing-charges/dto/billing-charge.dto'
import type { PlatformMode } from 'constants/platformMode'
import {
  PhysicianAddressJoined,
  PhysicianDto,
  PhysicianNoteDto,
  PhysiciansGroupPhysician,
  UpdatePhysicianSettingsDto,
} from 'ts-back-end/src/business/physician/dto/physician.dto'
import {
  CreateOrderDto,
  DeviceSession as DeviceSessionDto,
  OrderOutputDto,
  TestConditions,
} from 'ts-back-end/src/business/order/dto/create-order.dto'
import { AutomatedSmsDto } from 'ts-back-end/src/business/order/dto/automated-sms.dto'
import { VerificationResultDto } from 'ts-back-end/src/business/order/dto/verify-order.dto'
import { MessageEntity } from 'ts-back-end/src/business/message/entity/message.entity'
import { AddMessageDto } from 'ts-back-end/src/business/message/types/messages'
import { NoteEntity } from 'ts-back-end/src/business/note/entity/note.entity'
import { AddNoteDto } from 'ts-back-end/src/business/note/types/notes'
import type { StoreOffice } from 'ts-back-end/src/business/office/dto/office.dto'

export type { FollowUpModel } from 'ts-back-end/src/business/order/dto/follow-up'
export type { TestCode, TestTypesList } from 'ts-back-end/src/common/testtypes/test-types.const'
export type { UploadType } from 'ts-back-end/src/shared/files/utils'
export type { PatientRelationship } from 'ts-back-end/src/business/order/dto/request-aob.dto'
export type { DeviceDeliveryScheduledDto } from 'ts-back-end/src/business/order/dto/device.dto'
export type {
  DeviceDto,
  AssignThirdPartyDeviceDto,
} from 'ts-back-end/src/business/device/dto/device.dto'
export type { DefineHstDeviceDto } from 'ts-back-end/src/business/device/dto/device.dto'
export type { BucketValue } from 'ts-back-end/src/business/order/state-machine/order-state.const'
export type { LabBucketValue } from 'ts-back-end/src/business/order/state-machine/order-state.const'
export type {
  ProgressValues,
  StateExtended,
} from 'ts-back-end/src/business/order/queries/get-orders-list.query'
export type {
  IncomingDocumentEntry,
  IncomingDocumentsEntry,
} from 'ts-back-end/src/business/incoming-document/types/incoming-documents.types'
export type {
  AttachIncomingDocumentDto,
} from 'ts-back-end/src/business/incoming-document/types/incoming-documents.types'
export type {
  LabAssignThirdPartyDeviceDto,
  LabAssignDeviceAndStartShippingDto,
  SendNightOwlWelcomeDto,
  SubmitToNightOwlDto,
  LabRequestDeliveryDto,
  LabManualShippingDto,
  HoldNightOwlOrderDto,
  ReshipThirdPartyDeviceDto,
  RevertNightOwlOrder,
} from 'ts-back-end/src/business/night-owl/types/night-owl'
export type { RefundShippoTransactionDto } from 'ts-back-end/src/business/night-owl/types/shippo'
export type { OrderDisplayDmePayer } from 'ts-back-end/src/business/order/dto/assign-payer.dto'
export type { CompanyDto } from 'ts-back-end/src/business/company/dto/company.dto'
export type { CompaniesListQuery } from 'ts-back-end/src/business/company/dto/companies-list'
export type { CreateCompanyDto } from 'ts-back-end/src/business/company/dto/create-company.dto'
export type {
  BillingChargeProcedure,
  BillingChargeFile,
  ChargeDocument,
  ChargeAttachmentStatus,
  ChargeClaimStatusInfo,
  CreateBillingChargeDto,
  BillingChargeDto,
  BillingChargeLogEntry,
  BillingChargeSubmissionLogEntry,
  BillingChargesListQuery,
  BillingEraReportsListQuery,
  BillingChargesList,
  UpdateBillingChargeDto,
  BillingEraReportsList,
  AcceptEraClaimMatchDto,
  BillingArchiveEraClaimDto,
  BillingArchiveEraClaimsDto,
  BillingArchiveEraClaimsResult,
  EraClaimArchiveFailure,
  EraClaimOutcome,
  BillingEraPaymentSummary,
  BillingEraTransaction,
  BillingTransactionClaim,
  EraClaimMatchMethod,
  EraClaimMatchStatus,
  EraAutoPostReason,
  EraAutoPostState,
  EraAutoPostVerdictReason,
  EraClaimReviewState,
  EraClaimStateReason,
  EraExceptionQueueItem,
  EraExceptionQueueList,
  EraExceptionQueueQuery,
  ResolveEraCrossoverPayerDto,
  OptumClaimStatus,
  OptumClaimStatusSnapshot,
  BillingChargeOptumClaimStatusHistoryItem,
  SubmitBillingChargeFailure,
  SubmitBillingChargesResult,
} from 'ts-back-end/src/business/billing-charges/dto/billing-charge.dto'
export type { BillingChargeType } from 'ts-back-end/src/business/billing-charges/dto/billing-charge.dto'

export type {
  NeedsWorkReason,
  NeedsWorkStatus,
  NeedsWorkRemitAction,
  NeedsWorkRemitResolution,
  NeedsWorkItemDto,
  NeedsWorkListItem,
  NeedsWorkList,
  NeedsWorkListQuery,
  NeedsWorkParkedRemit,
  NeedsWorkRemitLine,
  NeedsWorkPerson,
  NeedsWorkFlagRequest,
  ParkEraClaimRequest,
  UpdateNeedsWorkRequest,
  ResolveNeedsWorkRequest,
  NeedsWorkPostCheck,
} from 'ts-back-end/src/business/billing-needs-work/dto/needs-work.dto'
export type { EraDocument } from 'ts-back-end/src/business/billing-charges/dto/billing-era-report.dto'
export type {
  PaymentInfo,
  ServiceLine,
  PaymentServiceLine,
  ServiceLineTransaction,
  ServiceLineAdjustmentCode,
  ServiceAdjustment
} from 'ts-back-end/src/business/billing-charges/dto/billing-era-report.dto'
export type {
  BillingPaymentDto,
  BillingPaymentsList,
  BillingPaymentsListQuery,
  CreateBillingPaymentDto,
  ChargeAccountRow,
  ChargeAccountServiceLine,
  ChargeAccountTransaction,
  ChargeAccountApplication,
  ChargeAccountLineApplication,
  ReleasedEraClaimsResult,
} from 'ts-back-end/src/business/billing-payments/dto/billing-payment.dto'
export type {
  EraClaimPlanBalances,
  EraPostingPlan,
} from 'ts-back-end/src/business/billing-payments/dto/era-posting.dto'
export type {
  AssignBillingDenialsDto,
  BillingDenialBulkResult,
  BillingDenialDto,
  BillingDenialLineDto,
  BillingDenialLineInput,
  BillingDenialReasonSummary,
  BillingDenialResolutionLine,
  BillingDenialResolveAction,
  BillingDenialWorklist,
  BillingDenialWorklistFilters,
  BillingDenialWorklistItem,
  BillingDenialWorklistQuery,
  MoveBillingDenialsDto,
  RecordEraDenialDto,
  RecordManualDenialDto,
  ResolveBillingDenialDto,
  ResolveBillingDenialsDto,
  ResubmitBillingDenialsDto,
} from 'ts-back-end/src/business/billing-denials/types/billing-denial.types'
export type { CrossoverResolution } from 'ts-back-end/src/business/billing-payments/types/era-crossover.types'
export type {
  CrossoverPayerCandidate,
  PayerCrossoverIdDto,
} from 'ts-back-end/src/business/payer/dto/payer-crossover-id.dto'
export type {
  BillingNote,
  BillingNoteDto,
  BillingNoteEntityType,
} from 'ts-back-end/src/business/billing-notes/dto/billing-note.dto'
export type {
  BillingAttachment,
  BillingAttachmentDto,
} from 'ts-back-end/src/business/billing-attachments/dto/billing-attachment.dto'
export type {
  BillingPatientStatementDto,
  BillingPatientStatementListItem,
  BillingPatientStatementsList,
  BillingPatientStatementsListQuery,
  PendingPatientStatementListItem,
  PendingPatientStatementsList,
  PendingPatientStatementsListQuery,
  OutstandingPatientBalanceItem,
  OutstandingPatientBalanceSelection,
  OutstandingPatientBalancesList,
  OutstandingPatientBalancesQuery,
  SendBillingPatientStatementDto,
  BillingPatientStatementWithDelivery,
  SendPatientStatementsDto,
  SendPatientStatementsResult,
  StatementDeliveryOutcome,
} from 'ts-back-end/src/business/billing-patient-statements/dto/billing-patient-statement.dto'
export type {
  PaperQueueItem,
  PaperQueueList,
  PatientReturnedMailDto,
  StatementPrintRunDto,
  StatementPrintRunDetailsDto,
  StatementPrintRunItemDto,
  StatementPrintRunsList,
} from 'ts-back-end/src/business/billing-patient-statements/dto/statement-print-run.dto'
export type {
  StatementReminderDto,
  StatementRemindersList,
  StatementRemindersQuery,
} from 'ts-back-end/src/business/billing-patient-statements/dto/statement-reminder.dto'
export type {
  BillingSettingsDto,
  UpdateBillingSettingsDto,
} from 'ts-back-end/src/business/billing-settings/dto/billing-settings.dto'

// Mirrors the back-end platform settings DTO, typed with the front-end enum.
export type PlatformSettingsDto = { platformMode: PlatformMode; updatedAt: string; canEdit: boolean }
export type UpdatePlatformSettingsDto = Pick<PlatformSettingsDto, 'platformMode'>
export type {
  PublicStatementDto,
  CreateStatementCheckoutSessionDto,
  CreateStatementCheckoutSessionResponse,
  PatientStatementLookupDto,
  PatientStatementLookupResponse,
} from 'ts-back-end/src/business/billing-patient-statements/dto/public-statement.dto'
export type {
  BatchSendBillingPaymentReceiptsDto,
  BillingPaymentReceiptDto,
  BillingPaymentReceiptsList,
  BillingPaymentReceiptsListQuery,
  CreateBillingPaymentReceiptDto,
  SendBillingPaymentReceiptDto,
} from 'ts-back-end/src/business/billing-payment-receipts/dto/billing-payment-receipt.dto'
export type {
  BillingPrepaymentDto,
  BillingPrepaymentsList,
  BillingPrepaymentsListQuery,
  CreateBillingPrepaymentDto,
  CreateBillingPrepaymentResponse,
  ApplyBillingPrepaymentDto,
  UpdateBillingPrepaymentDto,
} from 'ts-back-end/src/business/billing-prepayments/dto/billing-prepayment.dto'
export type {
  PatientTransactionsList,
  PatientTransactionsListQuery,
  PatientTransactionListingResponse,
} from 'ts-back-end/src/business/patient/dto/patient-transactions-list.dto'
export type {
  PatientAging,
  PatientAgingRow,
  PatientAgingQuery,
} from 'ts-back-end/src/business/patient/dto/patient-aging.dto'
export type {
  PatientAgingType,
  PatientAgingReport,
  PatientAgingOrder,
  PatientAgingOrdersPage,
} from 'ts-back-end/src/reporting/types/patient-aging-report'
export type {
  FollowUpCareReport,
  FollowUpCareReportItem,
  FollowUpCareReportPage,
  FollowUpCareReportFilter,
  FollowUpCareReportStatus,
  FollowUpCareReportProviderType,
} from 'ts-back-end/src/reporting/types/follow-up-care-report'
export type {
  PatientBalances,
  PatientBalancesQuery,
} from 'ts-back-end/src/business/patient/dto/patient-balances.dto'
export type {
  CreateOfficeDto,
  UpdateOfficeDto,
  StoreOffice,
  OutputOffice,
} from 'ts-back-end/src/business/office/dto/office.dto'
export type {} from 'packages/ts-back-end/src/business/office/dto/storeOffice'
export type { CreateUserDto, MeUserDto } from 'ts-back-end/src/business/user/dto/create-user.dto'
export type {
  SavedBucketDto,
  SavedBucketTestType,
} from 'ts-back-end/src/business/user/dto/saved-bucket.dto'
export type { UsersListQuery } from 'ts-back-end/src/business/user/dto/users-list'
export type { HstPatientPaperworkDto } from 'ts-back-end/src/business/order/dto/hst-patient-paperwork.dto'
export type { PoxShippingVerificationDto } from 'ts-back-end/src/business/order/dto/pox-shipping-verification.dto'
export type { ProvidePaymentAuthorizationDto } from 'ts-back-end/src/business/order/dto/payment-authorization'
export type { DeviceBrandsList } from 'ts-back-end/src/business/device/dto/device-brands-list'
export type { ReportRenderRequest } from 'ts-back-end/src/business/order/dto/create-order.dto'
export type {
  DevicesList,
  DevicesListQuery,
  DeviceListItem,
} from 'ts-back-end/src/business/device/dto/device-list.dto'
export type { CreateDeviceDto, DeviceHistoryItemDto } from 'ts-back-end/src/business/device/dto/device.dto'
export type {
  DeviceAccessory,
  DeviceAccessorySlot,
  DeviceInfo,
  DeviceShelfLifeInfo,
  DueAccessory,
} from 'ts-back-end/src/business/device/dto/device.dto'
export type {
  AccessoriesDueList,
  AccessoriesDueListItem,
  AccessoriesDueListQuery,
} from 'ts-back-end/src/business/device/dto/accessories-due-list.dto'
export type {
  DeviceComplaintDto,
  DeviceComplaintFileUrl,
  DeviceComplaintsCount,
  DeviceComplaintTemplate,
  FileDeviceComplaintDto,
  UpdateDeviceComplaintStatusDto,
} from 'ts-back-end/src/business/device-complaint/dto/device-complaint.dto'
export type {
  TimestampOverride,
  SelectedDeviceSessionsDto,
} from 'ts-back-end/src/business/order/dto/create-order.dto'
export type {
  CreateTicketDto,
  TicketDto,
  FreshDeskTicket,
  FreshDeskTicketsList,
} from 'ts-back-end/src/business/ticket/dto/create-ticket.dto'
export type { ListResult as TicketsList } from 'ts-back-end/src/business/ticket/dto/list-tickets.dto'

export type {
  CreateBulletinDto,
  BulletinDto,
  UpdateBulletinDto,
} from 'ts-back-end/src/business/bulletin/dto/bulletin.dto'
export type {
  CreateTagDto,
  TagDto,
  UpdateTagDto,
} from 'ts-back-end/src/business/tag/dto/tag.dto'
export interface CreatePatient extends Omit<CreatePatientDto, 'dob'> {
  dob: string
}
export type Patient = UpdatePatientDto & {
  id: string
  voiceOptOut?: boolean
  // The DME the patient chose (TES-3159); set through its own endpoint.
  preferredDmeOfficeId?: number | null
}

export type CreatePhysicianUserDto = {
  firstName: string
  lastName: string
  email: string
  physicianGroup: number
}

export type PhysicianOrders = { id: number; fullName: string; amount: number }

export type PhysicianOrderCounts = {
  total: PhysicianOrders | null
  month: PhysicianOrders | null
  lastMonth: PhysicianOrders | null
  year: PhysicianOrders | null
  completed: PhysicianOrders | null
}

export type PhysicianGroupDto = {
  id: number
  groupName: string
  telephone: string
  fax: string
  npi?: string
  physicians?: PhysiciansGroupPhysician[]
} & TheAddress

export interface Physician extends PhysicianDto {}
export interface PhysicianSettings extends UpdatePhysicianSettingsDto {}
export interface PhysicianNote extends PhysicianNoteDto {}

export type PhysicianAddress = PhysicianAddressJoined

export interface Payer extends PayerDto {}

export interface CreateOrder extends CreateOrderDto {}

export interface IOrderTest extends TestConditions {}
export interface Order extends OrderOutputDto {
  /** Live server-side Outsource-policy verdict with per-probe reasons (LAB order responses). */
  outsourceVisibility?: {
    visible: boolean
    hasVerification: boolean
    hasUnclearedPayer: boolean
    hasBlockedPayer: boolean
    hasUnlinkedPayer: boolean
  }
}

export type OutgoingDocumentListItem = {
  orderId: number
  fileKey: string
  fileName: string
  previewUrl: string
  uploadType: string
  faxStatus: 'PENDING' | 'SENT' | 'FAILED'
  faxedTo: string | null
  lastFaxAttempt: string | null
  faxError: string | null
  recipientName: string | null
  contents: string[] | null
}

// `attention` is the work queue (pending and failed) the menu badge counts.
export type OutgoingDocumentsStatus = 'attention' | 'sent' | 'all'

export type OutgoingDocumentsListResponse = {
  totalItems: number
  totalPages: number
  currentPage: number
  items: OutgoingDocumentListItem[]
}

export type DeviceSession = DeviceSessionDto & { originalIdx: number }

// just temporary
export type KeyVal = {
  [key: string]: string | Date | boolean | any
}

export type IdAndParam = {
  id: number | string
  params: KeyVal
}
export interface Company {}

export interface Office extends StoreOffice {}

export type Offices = Office[]

export type VerificationResult = VerificationResultDto

export enum VerificationSection {
  RX = 'RX',
  AOB = 'AOB',
  OFFICE_NOTES = 'OFFICE_NOTES',
  PATIENT = 'PATIENT',
  PAYER = 'PAYER',
  PAYER_2 = 'PAYER_2',
  PAYER_3 = 'PAYER_3',
  PHYSICIAN = 'PHYSICIAN',
}

export interface Message extends MessageEntity {
  userFirstName: string
  userLastName: string
  userEmail: string
}
export interface AutomatedSms extends AutomatedSmsDto {}
export interface AddMessage extends AddMessageDto {}

export interface Note extends NoteEntity {
  userFirstName: string
  userLastName: string
  userEmail: string
  source?: 'note' | 'aiConversationMemory'
  callDirection?: 'inbound' | 'outbound'
  readOnly?: boolean
}
export interface PayerNotes {
  notes?: string
  time?: string
  followUpDate?: string
}
export interface AddNote extends AddNoteDto {}

export enum UserType {
  LAB = 'LAB',
  DME = 'DME',
  PHYSICIAN_GROUP = 'PHYSICIAN_GROUP',
  SYSTEM = 'SYSTEM',
  ADMIN = 'ADMIN',
  PATIENT = 'PATIENT',
}

export enum HstDeviceKind {
  NIGHT_OWL = 'NIGHT_OWL',
  DREAM_CLEAR = 'DREAM_CLEAR',
  HST = 'HST',
  WESPER = 'WESPER',
}

export enum DreamclearStatus {
  S001 = 'Order Created',
  S002 = 'Device Shipped',
  S003 = 'Device Delivered',
  S004 = 'Test Data uploaded in Dreamclear for Night 1',
  S005 = 'Test Data uploaded in Dreamclear for Night 2',
  S006 = 'Test Not Completed for Night 1',
  S007 = 'Test Not Completed for Night 2',
  S008 = 'Data uploaded to Ensodata from DreamClear for Night 1',
  S009 = 'Data uploaded to Ensodata for Night 2',
  S010 = 'Scoring Completed for Night 1',
  S011 = 'Scoring Completed for Night 2',
  S012 = 'Scoring Completed but could not score one of the nights',
  S013 = 'Reports Downloaded to Dreamclear from Ensodata',
  S014 = 'Interpretation Signed in Dreamclear',
  S015 = 'Signed Report Transferred',
}

export enum DreamclearStatusCodes {
  S001 = 'S001',
  S002 = 'S002',
  S003 = 'S003',
  S004 = 'S004',
  S005 = 'S005',
  S006 = 'S006',
  S007 = 'S007',
  S008 = 'S008',
  S009 = 'S009',
  S010 = 'S010',
  S011 = 'S011',
  S012 = 'S012',
  S013 = 'S013',
  S014 = 'S014',
  S015 = 'S015',
}

export enum FollowUpNamespace {
  BILLING = 'BILLING',
  HST_PATIENT_CONSENT = 'HST_PATIENT_CONSENT',
  HST_PAPERWORK = 'HST_PAPERWORK',
  HST_PAYMENT = 'HST_PAYMENT',
  AUTHORIZATION = 'AUTHORIZATION',
  DEVICE = 'DEVICE',
  HST_DEVICE = 'HST_DEVICE',
  HST = 'HST',
  FOLLOW_UP_CARE = 'FOLLOW_UP_CARE',
  HST_PRE_AUTHORIZATION = 'HST_PRE_AUTHORIZATION',
}

export enum DeviceRemovalReason {
  LOST_BY_PATIENT = 'LOST_BY_PATIENT',
  DAMAGED_BY_PATIENT = 'DAMAGED_BY_PATIENT',
  LOST_BY_USPS = 'LOST_BY_USPS',
  DAMAGED_BY_USPS = 'DAMAGED_BY_USPS',
  WRONG_ADDRESS = 'WRONG_ADDRESS',
  RETEST_NOT_ENOUGH_DATA = 'RETEST_NOT_ENOUGH_DATA',
  DEVICE_ERROR = 'DEVICE_ERROR',
  NOT_USED = 'NOT_USED',
}

export enum NeededDeviceType {
  TYPE_3_UNSPECIFIED = 'Type 3 Unspecified',
  TYPE_3_WESPER = 'Type 3: Wesper',
  TYPE_3_ANO = 'Type 3: ANO',
  TYPE_3_CADWELL = 'Type 3: Cadwell',
  TYPE_3_CLEVEMED = 'Type 3: Clevemed',
  TYPE_4_CHECKME_02 = 'Type 4: Checkme 02',
  TYPE_4_CHECKME_02_PPG = 'Type 4: Checkme 02 PPG',
}

export const NEEDED_DEVICE_TYPES = Object.values(NeededDeviceType);

export type EraReportRecord = {
  id: string
  filename: string
  claimAmount: number
  hasOriginalFile?: boolean
  payments?: BillingEraPaymentSummary[]
  createdAt: string | Date
  updatedAt: string | Date
}

export enum EraImportStatus {
  IMPORTED = 'IMPORTED',
  PARTIALLY_IMPORTED = 'PARTIALLY_IMPORTED',
  DUPLICATE = 'DUPLICATE',
  EMPTY = 'EMPTY',
}

export type EraSkippedClaim = {
  claimNumber?: string
  patientName: string
  paidAmount: number
}

export type EraSkippedTransaction = {
  payerName?: string
  checkNumber?: string
  checkAmount: number
  claims: number
  claimDetails: EraSkippedClaim[]
  existingEraId?: string
  existingEraFilename?: string
  existingEraCreatedAt?: string
}

export type EraImportSummary = {
  status: EraImportStatus
  filename: string
  eraId?: string
  duplicateOfEraId?: string
  duplicateOfFilename?: string
  duplicateOfCreatedAt?: string
  importedTransactions: number
  importedClaims: number
  skippedClaims: number
  skippedTransactions: EraSkippedTransaction[]
}

export enum BillingPatientStatementStatus {
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  PAID = 'PAID',
}

export enum BillingPatientStatementDeliveryMethod {
  SMS = 'sms',
  EMAIL = 'email',
  MAIL = 'mail',
  PRINT = 'print',
  QUEUE = 'queue',
}

export enum BillingPaymentReceiptDeliveryMethod {
  SMS = 'sms',
  EMAIL = 'email',
}

// Mirrors the backend's statement cycle status. Declared rather than
// re-exported because the listing filters and pills use it as a value.
export enum BillingStatementCycleStatus {
  ACTIVE = 'ACTIVE',
  COLLECTIONS_REVIEW = 'COLLECTIONS_REVIEW',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  COLLECTIONS = 'COLLECTIONS',
  PAID = 'PAID',
  CLOSED = 'CLOSED',
}

export const billingStatementCycleStatusLabel = (status?: string | null): string => {
  if (!status) return '--'
  return BILLING_STATEMENT_CYCLE_STATUS_LABEL[status as BillingStatementCycleStatus] || status
}

export const BILLING_STATEMENT_CYCLE_STATUS_LABEL: Record<BillingStatementCycleStatus, string> = {
  [BillingStatementCycleStatus.ACTIVE]: 'In cycle',
  [BillingStatementCycleStatus.COLLECTIONS_REVIEW]: 'Collections review',
  [BillingStatementCycleStatus.PAYMENT_PLAN]: 'Payment plan',
  [BillingStatementCycleStatus.COLLECTIONS]: 'Collections',
  [BillingStatementCycleStatus.PAID]: 'Paid',
  [BillingStatementCycleStatus.CLOSED]: 'Closed',
}

// What each cycle step is called on screen, in the order the schedule runs
// them. Message steps are numbered the way the schedule numbers them.
export const BILLING_STATEMENT_CYCLE_STEP_LABEL: Record<string, string> = {
  MSG_1: 'Day 1 — balance due',
  MSG_2: 'Day 5 — reminder',
  MSG_3: 'Day 10 — final reminder',
  PAPER_15: 'Day 15 — paper statement',
  MSG_4: 'Day 30 — overdue',
  PAPER_30: 'Day 30 — paper statement',
  MSG_5: 'Day 45 — overdue reminder',
  PAPER_45: 'Day 45 — paper statement',
  MSG_6: 'Day 60 — final notice',
}

export const billingStatementCycleStepLabel = (stepKey?: string | null): string => {
  if (!stepKey) return '--'
  if (stepKey.startsWith('DRIP_')) return 'Overdue reminder'
  if (stepKey.startsWith('LEGACY_DAY_')) return `Day ${stepKey.slice('LEGACY_DAY_'.length)} — earlier text reminder`
  if (stepKey === 'LEGACY') return 'Earlier text reminder'
  return BILLING_STATEMENT_CYCLE_STEP_LABEL[stepKey] || stepKey
}

// Mirror the backend's paper statement queue enums, used here as values.
export enum PaperQueueView {
  READY = 'READY',
  HELD = 'HELD',
}

export enum PaperStatementHoldReason {
  NO_ADDRESS = 'NO_ADDRESS',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  UNBILLED_CROSSOVER = 'UNBILLED_CROSSOVER',
  RETURNED_MAIL = 'RETURNED_MAIL',
  ADDRESS_PROBLEM = 'ADDRESS_PROBLEM',
  OTHER = 'OTHER',
}

export const PAPER_STATEMENT_HOLD_REASON_LABEL: Record<PaperStatementHoldReason, string> = {
  [PaperStatementHoldReason.NO_ADDRESS]: 'No mailing address',
  [PaperStatementHoldReason.PAYMENT_PLAN]: 'Payment plan',
  [PaperStatementHoldReason.UNBILLED_CROSSOVER]: 'Crossed over to an unlisted payer',
  [PaperStatementHoldReason.RETURNED_MAIL]: 'Returned mail',
  [PaperStatementHoldReason.ADDRESS_PROBLEM]: 'Address problem',
  [PaperStatementHoldReason.OTHER]: 'Other',
}

// Holds a biller placed; the rest clear once the data is fixed.
export const RELEASABLE_PAPER_HOLD_REASONS: string[] = [
  PaperStatementHoldReason.ADDRESS_PROBLEM,
  PaperStatementHoldReason.OTHER,
]

export enum StatementNotMailedReason {
  NEEDS_REPRINT = 'NEEDS_REPRINT',
  ADDRESS_PROBLEM = 'ADDRESS_PROBLEM',
  PATIENT_PAID = 'PATIENT_PAID',
  OTHER = 'OTHER',
}

export const STATEMENT_NOT_MAILED_REASON_LABEL: Record<StatementNotMailedReason, string> = {
  [StatementNotMailedReason.NEEDS_REPRINT]: 'Needs reprint',
  [StatementNotMailedReason.ADDRESS_PROBLEM]: 'Address problem',
  [StatementNotMailedReason.PATIENT_PAID]: 'Patient already paid',
  [StatementNotMailedReason.OTHER]: 'Other',
}

export enum StatementPrintRunItemStatus {
  PRINTED = 'PRINTED',
  MAILED = 'MAILED',
  NOT_MAILED = 'NOT_MAILED',
  RETURNED = 'RETURNED',
  CANCELLED = 'CANCELLED',
}

export const STATEMENT_PRINT_RUN_ITEM_STATUS_LABEL: Record<StatementPrintRunItemStatus, string> = {
  [StatementPrintRunItemStatus.PRINTED]: 'Printed, not mailed',
  [StatementPrintRunItemStatus.MAILED]: 'Mailed',
  [StatementPrintRunItemStatus.NOT_MAILED]: 'Not mailed',
  [StatementPrintRunItemStatus.RETURNED]: 'Returned',
  [StatementPrintRunItemStatus.CANCELLED]: 'Cancelled',
}

export const STATEMENT_PRINT_RUN_ITEM_STATUS_COLOR: Record<StatementPrintRunItemStatus, string> = {
  [StatementPrintRunItemStatus.PRINTED]: '#fd7e14',
  [StatementPrintRunItemStatus.MAILED]: '#28a745',
  [StatementPrintRunItemStatus.NOT_MAILED]: '#dc3545',
  [StatementPrintRunItemStatus.RETURNED]: '#dc3545',
  [StatementPrintRunItemStatus.CANCELLED]: '#6c757d',
}

// Mirrors the backend's statement reminder status.
export enum StatementReminderStatus {
  SENT = 'SENT',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  DROPPED = 'DROPPED',
}

export const STATEMENT_REMINDER_STATUS_LABEL: Record<StatementReminderStatus, string> = {
  [StatementReminderStatus.SENT]: 'Sent',
  [StatementReminderStatus.FAILED]: 'Failed',
  [StatementReminderStatus.QUEUED]: 'Queued',
  [StatementReminderStatus.DROPPED]: 'Not printed',
}

export const STATEMENT_REMINDER_STATUS_COLOR: Record<StatementReminderStatus, string> = {
  [StatementReminderStatus.SENT]: '#28a745',
  [StatementReminderStatus.FAILED]: '#dc3545',
  [StatementReminderStatus.QUEUED]: '#fd7e14',
  [StatementReminderStatus.DROPPED]: '#6c757d',
}

export const STATEMENT_REMINDER_CHANNEL_LABEL: Record<string, string> = {
  [BillingPatientStatementDeliveryMethod.SMS]: 'Text',
  [BillingPatientStatementDeliveryMethod.EMAIL]: 'Email',
  [BillingPatientStatementDeliveryMethod.MAIL]: 'Paper',
}

export type StatementNotMailedDto = {
  reason: StatementNotMailedReason
  note?: string | null
}

export enum ProviderType {
  INDIVIDUAL = 'individual',
  ORGANIZATION = 'organization',
}

export enum PhysicianType {
  REFERRING = 'REFERRING',
  FOLLOW_UP = 'FOLLOW_UP',
  INTERPRETING = 'INTERPRETING',
}
